import React from 'react';

import { SvgIcon } from '@material-ui/core';

function CloneForceIcon() {
  return (
    <SvgIcon>
      <path
        fill="none"
        stroke="currentColor"
        stroke-width="0.88"
        d="M 21.18,2.23
           C 21.18,2.23 5.88,2.23 5.88,2.23
             5.85,2.22 5.82,2.22 5.79,2.22
             5.24,2.22 4.79,2.64 4.74,3.18
             4.74,3.18 4.74,23.72 4.74,23.72
             4.74,23.72 11.34,23.72 11.34,23.72
             11.34,23.72 11.34,16.04 11.34,16.04
             11.34,16.04 20.48,16.04 20.48,16.04
             20.48,16.04 20.48,12.38 20.48,12.38
             20.43,11.85 19.98,11.43 19.43,11.43
             19.41,11.43 19.38,11.43 19.36,11.44
             19.36,11.44 11.35,11.44 11.35,11.44
             11.35,11.44 11.35,7.80 11.35,7.80
             11.40,7.26 11.86,6.83 12.42,6.83
             12.44,6.83 12.47,6.83 12.50,6.83
             12.50,6.83 22.31,6.83 22.31,6.83
             22.31,6.83 22.31,3.17 22.31,3.17
             22.26,2.64 21.81,2.22 21.26,2.22
             21.23,2.22 21.21,2.22 21.18,2.23
             21.18,2.23 21.18,2.23 21.18,2.23 Z"
      />
      <path
        fill="currentColor"
        d="M 19.21,0.00
           C 19.21,0.00 3.60,0.00 3.60,0.00
             3.57,-0.00 3.53,-0.01 3.50,-0.01
             2.91,-0.01 2.44,0.47 2.44,1.05
             2.44,1.12 2.45,1.19 2.46,1.26
             2.46,1.26 2.46,21.80 2.46,21.80
             2.46,21.80 9.06,21.80 9.06,21.80
             9.06,21.80 9.06,14.12 9.06,14.12
             9.06,14.12 18.20,14.12 18.20,14.12
             18.20,14.12 18.20,10.46 18.20,10.46
             18.15,9.93 17.70,9.51 17.15,9.51
             17.12,9.51 17.10,9.51 17.07,9.52
             17.07,9.52 9.07,9.52 9.07,9.52
             9.07,9.52 9.07,5.87 9.07,5.87
             9.12,5.33 9.58,4.91 10.14,4.91
             10.16,4.91 10.18,4.91 10.20,4.91
             10.20,4.91 20.02,4.91 20.02,4.91
             20.02,4.91 20.02,1.25 20.02,1.25
             19.89,1.22 19.75,1.21 19.61,1.21
             18.58,1.21 17.74,2.05 17.74,3.08
             17.74,3.97 18.37,4.72 19.20,4.91
             19.20,4.91 19.21,0.00 19.21,0.00 Z"
      />
    </SvgIcon>
  );
}

export default CloneForceIcon;
